export default __webpack_public_path__ + "static/media/icon_delete.515cfa94.svg";